import React from "react";
import {
  Grid,
  GridItem,
  Text,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { MethodClassIcon } from "components/Icons";
import BankMoreOptionsMenu from "components/PaymentMethodSelector/BankMoreOptionsMenu";

const BankName = ({ name }) => {
  return <Text fontSize="xs">{name}</Text>;
};

// TODO:  This is almost identical to /components/PaymentMethodSelector/BankAccount.js, we should remove or swap implementations when we move from the old payout flow to payout v2
const BankAccount = ({
  bankAccount,
  onUpdate,
  isSelected,
  disabled,
  onBankAccountClick,
  ...props
}) => {
  return (
    <Grid
      p="4"
      borderWidth="1px"
      borderRadius="4px"
      gap="2"
      templateColumns="1fr 11fr"
      onClick={() => onBankAccountClick(bankAccount)}
      bgColor={isSelected ? "lightBackground" : "background"}
      borderColor={isSelected && "integrator.300"}
      opacity={disabled ? 0.5 : 1}
      pointerEvents={disabled ? "none" : "all"}
      boxShadow="base"
      cursor="pointer"
      data-testid={`bank-account-${bankAccount.bank_account_id}`}
      {...props}
    >
      <GridItem>
        <MethodClassIcon name={bankAccount.institution_name} />
      </GridItem>
      <GridItem gridColumn="2/-1">
        <HStack justify="space-between">
          <VStack align="flex-start" gap="0">
            <BankName name={bankAccount.display_string} />
            {bankAccount.institution_name && (
              <Text fontSize="sm" color="secondaryText" textTransform="uppercase">
                {bankAccount.institution_name}
              </Text>
            )}
          </VStack>
          <BankMoreOptionsMenu bankAccount={bankAccount} onComplete={onUpdate} />
        </HStack>
      </GridItem>
    </Grid>
  );
};

export default BankAccount;
